export const S3_IMPORT_TEMPLATE_FOLDER = "S3-Import-Sample-Template";

export const IMPORT_TEMPLATES = {
  LeadsXLSX: "SampleXLSXFileLeads.xlsx",
  LeadsCSV: "SampleCSVFileLeads.csv",
  CustomersXLSX: "SampleXLSXFileCustomers.xlsx",
  CustomersCSV: "SampleCSVFileCustomers.csv",
  LeadsFullCircleXLSX: "SampleXLSXFileLeadsFullCircle.xlsx",
  LeadsFullCircleCSV: "SampleCSVFileLeadsFullCircle.csv",
};